import moment from 'moment'
import createPaginationModule from '../generic/pagination'
import createSingleItemCrudModule from '../generic/single-item-crud'
import { putPushNotificationMarkAsReadApi } from './logistics-apis'
import { NOTIFICATIONS_PUSH_NOTIFICATION_SUGGESTIONS, NOTIFICATION_PUSH_NOTIFICATION_ALLOWED_SEARCH_INPUTS } from './search-inputs'
import { RETRIEVE } from '@/constants/store-actions'
const endpoint = '/user_api/v1/push_notifications'
const url = (
  process.env.VUE_APP_USER_API_ENDPOINT +
  endpoint
)

function parsePushNotificationItems (item) {
  return {
    user_email: item.user_email,
    plant: item.plant,
    planner_group: item.planner_group,
    storage_location: item.storage_location,
    work_center: item.work_center,
    title: item.title,
    message: item.message,
    created: moment(item.created).format('lll')
  }
}

export default {
  namespaced: true,
  modules: {
    pushNotificationPagination: createPaginationModule(
      {
        endpoint: url,
        mapper: parsePushNotificationItems
      }),
    pushNotificationCrud: createSingleItemCrudModule(
      {
        endpoint: url,
        actions: [RETRIEVE]
      })
  },
  state: {
  },
  getters: {
    searchSuggestionsList (state) {
      return NOTIFICATIONS_PUSH_NOTIFICATION_SUGGESTIONS
    },
    allowedSearchInputs (state) {
      return NOTIFICATION_PUSH_NOTIFICATION_ALLOWED_SEARCH_INPUTS
    }
  },
  actions: {
    async markAsRead ({ commit }, id) {
      const requestPromise = putPushNotificationMarkAsReadApi(id)
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.error({ _: 'Mark Push Notification As Read failed', error })
        })
      return requestPromise
    }
  }
}
